import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetWidgetConfigurationResponseData } from "schema"
import { z } from "zod"

type Response = DataResponse<z.input<typeof GetWidgetConfigurationResponseData>>
type OnSuccessFn = (data: Response["data"]) => void

const getWidgetConfigurationQueryKey = () => ["widgetConfiguration"]

type Props = {
  onSuccess?: OnSuccessFn
}

export const getWidgetConfigurationQuery = ({ onSuccess }: Props) => {
  return queryOptions({
    queryKey: getWidgetConfigurationQueryKey(),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/integrations/widget`)
      onSuccess?.(data.data)
      return data.data
    },
    refetchOnWindowFocus: false,
  })
}
